import React from 'react';

import Typography from '@material-ui/core/Typography';

export function PeopleSection() {
  return <Typography paragraph>This is the people section</Typography>;
}
